import { CoverageIdEnum, PolicyProductIdEnum } from 'outshared-lib';

// TODO: Add ORB to CoverageIdEnum
export const coverageOrderOptionsConfig = {
    [PolicyProductIdEnum.Car]: {
        [CoverageIdEnum.CarLegalLiability]: 1,
        [CoverageIdEnum.CarLimitedCasco]: 1,
        [CoverageIdEnum.CarLimitedCascoExtra]: 1,
        [CoverageIdEnum.CarAllrisk]: 1,
        [CoverageIdEnum.CarDamageInsuranceOccupants]: 3,
        [CoverageIdEnum.CarRoadsideAssistanceNetherlands]: 4,
        [CoverageIdEnum.MotorAccidentPermanentInjury]: 6,
        [CoverageIdEnum.MotorAccidentDeath]: 7,
        [CoverageIdEnum.CarRedressLegalAid]: 200,
    },
    [PolicyProductIdEnum.Bicycle]: {
        [CoverageIdEnum.BicycleTheft]: 1,
        [CoverageIdEnum.BicycleAllrisk]: 1,
        [CoverageIdEnum.BicycleHomeDeliveryService]: 3,
        [CoverageIdEnum.Liability]: 200,
    },
};
